import { Routes, Route, Navigate } from 'react-router-dom'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import { useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import LandingPage from './pages/LandingPage'
import { ErrorBoundary } from './components/ErrorBoundary'
import Dashboard from './pages/Dashboard'
import Coffins from './pages/Coffins'
import Clients from './pages/Clients'
import ClientDetailPage from './pages/ClientDetailPage'
import Payments from './pages/Payments'
import InvoiceDetail from './pages/InvoiceDetail'
import InvoicePrintPreview from './pages/InvoicePrintPreview'
import PaymentDetail from './pages/PaymentDetail'
import Reports from './pages/Reports'
import Configuration from './pages/Configuration'
import ConfigurationEmailNotifications from './pages/ConfigurationEmailNotifications'
import FiscalCenter from './pages/FiscalCenter'
import NotificationPreferences from './pages/NotificationPreferences'
import AuditLog from './pages/AuditLog'
import PlanTemplates from './pages/PlanTemplates'
import Users from './pages/Users'
import TestUpload from './pages/TestUpload'
import Notifications from './pages/Notifications'
import { LoadingSpinner } from './components/ui'
import PWAUpdateNotification from './components/PWAUpdateNotification'
import PlatformLayout from './components/PlatformLayout'
import PlatformFunerarias from './pages/platform/PlatformFunerarias'
import PlatformIncidents from './pages/platform/PlatformIncidents'
import PlatformTenantProfile from './pages/platform/PlatformTenantProfile'
import PlatformPlans from './pages/platform/PlatformPlans'
import ServiceActivations from './pages/ServiceActivations'
import CompletePayment from './pages/CompletePayment'
import Cobros from './pages/Cobros'

function App() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Register />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    )
  }

  if (user.role === 'PLATFORM_OWNER') {
    return (
      <PlatformLayout>
        <PWAUpdateNotification />
        <Routes>
          <Route path="/platform/incidents" element={<PlatformIncidents />} />
          <Route path="/platform/plans" element={<PlatformPlans />} />
          <Route path="/platform/tenants/:tenantId" element={<PlatformTenantProfile />} />
          <Route path="/platform" element={<PlatformFunerarias />} />
          <Route path="/" element={<Navigate to="/platform" replace />} />
          <Route path="*" element={<Navigate to="/platform" replace />} />
        </Routes>
      </PlatformLayout>
    )
  }

  const paymentPending = user?.subscription?.status === 'PENDING_PAYMENT'

  if (paymentPending) {
    return (
      <Routes>
        <Route path="/completar-pago" element={<CompletePayment />} />
        <Route path="*" element={<Navigate to="/completar-pago" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <PWAUpdateNotification />
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/plan-templates" element={<PlanTemplates />} />
          <Route path="/coffins" element={<Coffins />} />
          <Route path="/service-activations" element={<ServiceActivations />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/:id" element={<ClientDetailPage />} />
          <Route path="/cobros" element={<Cobros />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payments/:id" element={<PaymentDetail />} />
          <Route path="/invoices" element={<Navigate to="/cobros?tab=facturas" replace />} />
          <Route path="/invoices/:id" element={<InvoiceDetail />} />
          <Route path="/invoices/:id/print" element={<InvoicePrintPreview />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/users" element={<Users />} />
          <Route path="/configuration" element={<Configuration />} />
          <Route path="/configuration/fiscal" element={<FiscalCenter />} />
          <Route path="/configuration/email-notifications" element={<ConfigurationEmailNotifications />} />
          <Route path="/configuration/audit" element={<AuditLog />} />
          <Route path="/settings/notifications" element={<NotificationPreferences />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/test-upload" element={<TestUpload />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </ErrorBoundary>
    </Layout>
  )
}

export default App
